import "svgxuse";
import "swiper/dist/css/swiper.min.css";
import "simplebar/dist/simplebar.min.css";
import "video.js/dist/video-js.min.css";

import Vue from "vue";
import Core from "@/core/install";
import DayjsPlugin from "@/core/services/dayjs";
import Vuelidate from "vuelidate";

import SvgIcon from "@/components/common/svg/SvgIcon";
import DropdownMenu from "@/components/ui/dropdown/DropdownMenu";
import AppBtn from "@/components/ui/button/AppBtn";

import Modals from "@/components/ui/modal";

import AppSelect from "@/components/ui/select/AppSelect.vue";

import AppHover from "@/components/interactives/AppHover";
import AppLoading from "@/components/interactives/AppLoading";
import PageTitle from "@/components/common/PageTitle";

Vue.use(Vuelidate);
Vue.use(DayjsPlugin);
Vue.use(Modals);

let components = {
  AppBtn,
  SvgIcon,
  DropdownMenu,
  AppSelect,
  AppHover,
  AppLoading,
  PageTitle
};

Vue.use(Core, { components });
